module.exports = __webpack_public_path__ + "static/kay_baldwin-fc0ffc97e553ec5a300ff6c54940f75f.jpg";